import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Routes from './Routes';
import { CartProvider } from './contexts/CartContext';
import useDynamicFavicon from './hooks/useDynamicFavicon';

// Helper component to handle URL parameters
const PaymentStatusListener = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params?.get('status');

    if (status === 'payment_success') {
      // 1. Clear Cart
      localStorage.removeItem('cartItems');
      localStorage.removeItem('cart');
      window.dispatchEvent(new Event('storage')); // Notify other tabs/components

      // 2. Show UI Feedback
      alert("✅ Ödeme Başarılı! Siparişiniz alındı.");

      // 3. Clean URL
      navigate('/', { replace: true });
    }

    if (params?.get('error') === 'payment_failed') {
      alert("❌ Ödeme işlemi tamamlanamadı.");
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return null;
};

// Meta Pixel PageView tracker — fires on every route change
const MetaPixelPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location?.pathname]);

  return null;
};

function App() {
  useDynamicFavicon();

  return (
    <CartProvider>
      <PaymentStatusListener />
      <MetaPixelPageView />
      <Routes />
    </CartProvider>
  );
}

export default App;